export default __webpack_public_path__ + "static/media/polygonasset.a5258d31.png";